export const environment = {

    backEndServer: {

        apiBaseUrl: 'https://apimtlvprd.tel-aviv.gov.il/WADGTBIZregistration/api',
    },

    recaptcha: {

        siteKey: '6Ld5tfkrAAAAAFyGx0D9s5ScipdvOc50nutx8rna',
    },

    publicPetition: {

        url: 'https://muni4u.tel-aviv.gov.il/public-petition/ident/digitelbusiness'
    },

    bizSiteUrl: 'https://mydigitelbiz.tel-aviv.gov.il/',

    regulationsUrl: 'https://www.tel-aviv.gov.il/Business/Pages/BusinessDigitelTerms.aspx',

    bizRegTermsUrl: 'https://www.tel-aviv.gov.il/Business/Pages/digitelbusiness.aspx',

    bizExplainUrl: 'https://www.tel-aviv.gov.il/Business/Pages/Business.aspx',

    GlassBoxUri: "reportURI=https://report.c3001.gbqofs.io/yl87mo4g/reporting/44056d4c-a0b3-2d53-db00-45adb84528b2/cls_report;",

    GlassBoxDetectorPath: "https://cdn.gbqofs.com/tlvm/u/detector-dom.min.js",

    smartBizLink: "https://tlvapp.app.link/business?finishreg=1",

    msal: {
        auth: {
            clientId: "43d33f16-69a3-4ce8-93e8-6e9707b17f8e",
            authority: "https://b2ctam.b2clogin.com/b2ctam.onmicrosoft.com/B2C_1A_TLVPRDNEW_SIGNIN",
            redirectUri: "https://mydigitelbizreg.tel-aviv.gov.il/",
            knownAuthorities: ["b2ctam.b2clogin.com"]
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false
        },
        guard: {
            interactionType: "redirect",
            authRequest: {
                scopes: ["https://b2ctam.onmicrosoft.com/WebAppDigitelNewPictureSiteApiPrd/access_as_user", "openid"]
            }
        }
    },
}